import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PackageType } from 'src/app/core/models/package-type.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { LicenseService } from 'src/app/core/services/license.service';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';

@Component({
  selector: 'hbo-package-type-list',
  templateUrl: './package-type-list.component.html',
  styleUrls: ['./package-type-list.component.scss']
})
export class PackageTypeListComponent implements OnInit {

  packageTypes$ = new Observable<Pagination<PackageType>>;

  user: User = utils?.localStorageGetItem('user');

  constructor(
    private licenseService: LicenseService
  ) { }

  ngOnInit() {
    this.searchPackageTypes();
  }

  searchPackageTypes(pagination?: PaginationRequest) {
    this.packageTypes$ = this.licenseService.indexPackageTypes(pagination ?? {});
  }

}
